export const EMOJI_SAMPLE = [
  "😀",
  "😁",
  "😂",
  "🤣",
  "😃",
  "😄",
  "😅",
  "😆",
  "😉",
  "😊",
  "😋",
  "😎",
  "😍",
  "😘",
  "😗",
  "😙",
];

export const SPECIAL_CHARACTERS = ["!", "@", "#", "$", "%", "^", "&", "*"];
